import React, { useRef, useEffect, useState } from "react";
import Dropdown from "./Dropdown/Dropdown";

function useOutsideAlerter(ref, onClickOutside) {
    useEffect(() => {
        /**
         * Alert if clicked on outside of element
         */
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                onClickOutside();
            }
        }
        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref]);
}

export default function ShareLink(props) {
    let url = props.elem?.dataset?.url ? props.elem.dataset.url : props.url;
    let message = props.elem?.dataset?.message ? props.elem.dataset.message : props.message;
    let title = props.elem?.dataset?.title ? props.elem.dataset.title : props.title;
    let [dropdownOpen, setDropdownOpen] = useState(false);
    const wrapperRef = useRef(null);
    useOutsideAlerter(wrapperRef, closeDropdown);

    return (
        <div onClick={openDropdown} ref={wrapperRef} className="btn icon-btn-wrapper m-0">
            <p className="text-white">Megosztás</p>
            <img className="btn-icon" src="../../../images/icon/sharing.svg" alt="share" />
            {dropdownOpen && <Dropdown url={url} message={message} title={title} />}
        </div>
    );

    function closeDropdown() {
        setDropdownOpen(false);
    }

    function openDropdown() {
        setDropdownOpen(true);
    }
}
